import {
  ExclamationTriangleIcon,
  XCircleIcon,
} from "@heroicons/react/20/solid";

export default function Alert({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <div className="rounded-md bg-yellow-50 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <ExclamationTriangleIcon
              className="h-5 w-5 text-yellow-400"
              aria-hidden="true"
            />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800">{title}</h3>
            <div className="mt-2 text-sm text-yellow-700">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function AlertError({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="relative rounded-lg border border-red-200 bg-gradient-to-r from-red-50 to-red-25 p-4 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-red-100">
            <XCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
          </div>
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-sm font-semibold text-red-900">{title}</h3>
          <div className="mt-1 text-sm text-red-700 leading-relaxed">{children}</div>
        </div>
      </div>
      <div className="absolute inset-x-0 top-0 h-1 rounded-t-lg bg-gradient-to-r from-red-400 to-red-500"></div>
    </div>
  );
}
